import { useState } from 'react';
import { faqs } from '@/mocks/home';
import SectionHeading from '@/components/base/SectionHeading';

export default function FaqSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="使用帮助"
              title="常见问题"
              desc="关于黑料总站的汇总范围、分类浏览与更新节奏，先看这几个问题就够了。"
            />
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-100/50">
              {faqs.map((item, index) => {
                const isOpen = activeIndex === index;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => setActiveIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-label text-sm font-medium text-foreground-900">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          isOpen
                            ? 'border-primary-300 bg-primary-100 text-primary-700'
                            : 'border-background-300 text-foreground-500'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                      </span>
                    </button>
                    {isOpen ? (
                      <div className="px-5 pb-5">
                        <p className="max-w-2xl text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}